import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';
import {Tab} from '../message/Tab';
import {TabCriteria} from './TabCriteria';

export class TabWrapper extends BaseWrapper<Tab, TabCriteria, BasicScenario>  {}

